export default __webpack_public_path__ + "static/visual_1-1e44fdbf683e9e33c2403a10be657439.jpg";